export default __webpack_public_path__ + "static/media/case2-2 (1).17473d74.png";